export default __webpack_public_path__ + "static/media/absences.e9c295ef.png";